export default __webpack_public_path__ + "static/media/dots_circle_active.e65ead58.png";